import {
  useTracking,
  type GlycerinImageClickPayload,
  type GTMEventGlycerinImageClick,
} from '@packages/tracking';
import type { FC } from 'react';
import type { ImageProps } from 'next/image';
import NextImage from 'next/image';
import { akamaiLoader } from './loader';

export type NextImageProps = ImageProps & {
  clickTrackingProps?: GlycerinImageClickPayload;
};

// TODO: img sizes and akamai settings tbd and custom akamai image loader has to be build
export const getImageSize = (src: NextImageProps['src']) => {
  const type = typeof src === 'string' && src?.split('?').pop();
  switch (type) {
    case '$PL_portrait_hq$':
      return { width: 339, height: 485 };
    case '$PL_landscape_hq$':
      return { width: 399, height: 236 };
    case '$PL_square_highlight$':
      return { width: 1000, height: 1000 };
    default:
      // TODO: check what if no case match
      // return { width: 339, height: 485 };
      return undefined;
  }
};

/**
 * Image component based on https://nextjs.org/docs/basic-features/image-optimization
 * */
export const Image: FC<NextImageProps> = ({
  src,
  width,
  height,
  onClick,
  clickTrackingProps,
  ...props
}) => {
  const dispatchGTMEvent = useTracking();
  const { category, detail, imageId, label, placement, source, target, variantIds, custom } =
    clickTrackingProps ?? {};
  let imagesrc: string;
  if (typeof src === 'object') {
    if ('default' in src) {
      imagesrc = src.default.src;
    } else {
      imagesrc = src.src;
    }
  } else {
    imagesrc = src;
  }

  return (
    <NextImage
      onClick={(event) => {
        dispatchGTMEvent<GTMEventGlycerinImageClick>({
          event: 'ImageClick',
          ImageClickData: {
            category: category ?? 'image-click',
            detail,
            imageId,
            label,
            placement,
            source: source ?? imagesrc,
            target,
            variantIds,
            custom,
          },
        });
        if (onClick) {
          onClick(event);
        }
      }}
      src={src}
      width={width || getImageSize(src)?.width}
      height={height || getImageSize(src)?.height}
      loader={akamaiLoader}
      {...props}
    />
  );
};
